// CipSkeleton.jsx
import React from 'react'

export default function CipSkeleton() {
  return (
    <div
      role="status"
      className="mx-auto w-[900px] min-h-[1200px] p-6 space-y-8
                 border border-gray-200 rounded-sm shadow-sm
                 animate-pulse"
    >
      {/* 1. CIP Title/Heading area */}
      <section className="space-y-2">
        {/* CIP code */}
        <div className="h-6 bg-gray-300 rounded-sm w-1/3"></div>
        {/* CIP name */}
        <div className="h-4 bg-gray-200 rounded-sm w-2/5"></div>
      </section>

      {/* 2. Short Description */}
      <section className="space-y-2">
        <div className="h-3 bg-gray-200 rounded-sm w-4/5"></div>
        <div className="h-3 bg-gray-200 rounded-sm w-3/5"></div>
      </section>

      {/* 3. Tabs (Enrollments, Labor Market Info, Equity) */}
      <section className="flex space-x-4 pt-4">
        <div className="h-6 w-28 bg-gray-200 rounded-sm"></div>
        <div className="h-6 w-36 bg-gray-200 rounded-sm"></div>
        <div className="h-6 w-24 bg-gray-200 rounded-sm"></div>
      </section>

      {/* 4. First Table Section */}
      <section className="space-y-4 mt-6">
        {/* Table Heading */}
        <div className="h-5 bg-gray-300 rounded-sm w-3/5"></div>

        {/* Table Skeleton */}
        <div className="space-y-2">
          {/* Header row */}
          <div className="flex space-x-2">
            <div className="h-4 bg-gray-300 rounded-sm w-1/4"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
          </div>
          {/* Data rows */}
          {Array.from({ length: 3 }).map((_, idx) => (
            <div className="flex space-x-2" key={idx}>
              <div className="h-4 bg-gray-200 rounded-sm w-1/4"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
            </div>
          ))}
        </div>
      </section>

      {/* 5. Second Table Section */}
      <section className="space-y-4 mt-6">
        {/* Table Heading */}
        <div className="h-5 bg-gray-300 rounded-sm w-2/3"></div>

        {/* Table Skeleton */}
        <div className="space-y-2">
          {/* Header row */}
          <div className="flex space-x-2">
            <div className="h-4 bg-gray-300 rounded-sm w-1/4"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
            <div className="h-4 bg-gray-300 rounded-sm w-1/6"></div>
          </div>
          {/* Data rows */}
          {Array.from({ length: 3 }).map((_, idx) => (
            <div className="flex space-x-2" key={idx}>
              <div className="h-4 bg-gray-200 rounded-sm w-1/4"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
              <div className="h-4 bg-gray-200 rounded-sm w-1/6"></div>
            </div>
          ))}
        </div>
      </section>

      {/* 6. Optional Chart/Image Placeholder */}
      <section className="mt-6 flex items-center justify-center h-48 bg-gray-300 rounded-sm">
        <svg
          className="w-10 h-10 text-gray-200"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
        </svg>
      </section>

      {/* 7. Optionally, a “Show More” or “Load More” button placeholder */}
      <section className="mt-8 flex justify-end">
        <div className="h-8 w-32 bg-gray-200 rounded-sm"></div>
      </section>

      <span className="sr-only">Loading...</span>
    </div>
  )
}